export default "__VITE_ASSET__6d39cc41__"